import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
// TODO: Change to reflect login status
function FAQList(props) {
  return (
    <div>
      <Accordion className="FAQ">
        <Card>
          <Accordion.Toggle eventKey="0">
            <Card.Header>

              {props.question}
            </Card.Header>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body>
              {' '}
              {props.answer}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

    </div>

  );
}

export default FAQList;
